const MenuItems = [
    // {
    //     id:1,
    //     name:"Top Artists",
    //     link:'/artists'
    // },
    // {
    //     id:2,
    //     name:"Top Tracks",
    //     link:'/tracks'
    // },
    {
        id:3,
        name:"BillBoard Top 50",
        link:'/billboardtop50'
    },
    {
        id:4,
        name:"India Top 50",
        link:'/indiatop50'
    }
]

export default MenuItems;